<template>
  <!-- the api response is displayed here to inform the user -->
  <div class="paddingSmallTop apiResponse marginSmallBottom">
    <!-- a nice transition when the api result changes -->
    <transition
      name="fade"
      mode="out-in"
    >
      <span v-if="customMessage">
        <span
          class="fontBold colorGrey"
          :class="{colorError: customMessageStatus === 'failure', colorSuccess: customMessageStatus === 'success'}"
        >

          <!-- the custom message -->
          {{ customMessage }}
        </span>
      </span>

      <!-- continue as long as we have a context for this api response -->
      <span
        v-else-if="typeof (apiResponse[context]) !== 'undefined'"
        :key="apiResponse[context].message"
      >

        <!-- the apiResponse component was invoked in "no details" mode -->
        <span
          v-if="!details"
          class="fontBold"
          :class="{colorError: apiResponse[context].result === 'failure', colorSuccess: apiResponse[context].result === 'success'}"
        >

          <!-- the message from the api response -->
          {{ apiResponse[context].message }}
        </span>
				
        <!-- the component was invoked asking to show the details from the api response rather than the message -->
        <!-- the details from the api response -->
        <span
          v-else
          v-html="apiResponse[context].payload.details"
        />
      </span>
    </transition>
  </div>
</template>

<script>

export default {
	name: 'ApiResponse',
	props: [
		'context',
		'details',
		'customMessage',
		'customMessageStatus'
	],
	data () {
		return {}
	},
	computed: {
		apiPending: function () {
			return this.$store.getters.apiPending
		},
		apiResponse: function () {
			return this.$store.getters.apiResponse
		}
	},
	mounted () {
	},
	beforeDestroy () {
		this.$store.dispatch('clearApiResponse', this.context)
	}
}
</script>

<style scoped>
</style>
